import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import {getUserAllocation, setSettingsAllocationDetailsModalStatus} from "../../store/cabinet/action";


const SettingsAllocation = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const userAllocation = useSelector(store => store.cabinet.userAllocation);


    useEffect(() => {
        dispatch(getUserAllocation());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Полученные аллокации')}</div>
                <div className={`${Styles.contentWrapNote}`}>View and manage your wallets, transactions, and financial settings.</div>
                <div className={`${Styles.contentBox}`}>
                    {userAllocation?.allocations?.length > 0 ? userAllocation.allocations?.map((item, index)=>{
                        return (
                            <div className={`${Styles.contentBoxItem}`} key={'fakeAllocation' + index}>
                                <div className={`${Styles.contentBoxItemAmountRow}`}>
                                    <div className={`${Styles.contentBoxItemAmountRowImgWrap}`}>
                                        <img src={item?.project?.logo} alt={item?.project?.description?.title}/>
                                    </div>
                                    <div className={`${Styles.contentBoxItemAmount}`}>
                                        <div className={`${Styles.contentBoxItemAmountName} ${Styles.titleWSF}`}>{t('Сумма аллокации')}</div>
                                        <div className={`${Styles.contentBoxItemAmountValue} ${Styles.titleWSF}`}>{item?.allocation_total * 1}$</div>
                                    </div>
                                </div>
                                <div className={`${Styles.contentBoxItemTitle}`}>{item?.project?.description?.title}</div>
                                <div className={`${Styles.contentBoxItemNote}`}>{item?.project?.description?.short_description}</div>
                                <div className={`${Styles.contentBoxItemInfoBtn} ${Styles.btn}`} onClick={()=>{dispatch(setSettingsAllocationDetailsModalStatus({status: true, data: item}))}}>{t('Подробнее')}</div>
                            </div>
                        )
                    }) : null}
                </div>
            </div>
        </section>
    );
};

export default SettingsAllocation;